import React from 'react';

import { Box } from '@mui/material';

import { StatisticsChart } from './StatisticsChart';

export const StatisticsTab = ({ tab, filters }) => (
  <Box display="grid" gridTemplateColumns={{ xs: '1fr', lg: '1fr 1fr' }} gap={3}>
    {tab.charts.map(({ metric, title }) => (
      <StatisticsChart
        key={metric}
        metric={metric}
        title={title}
        countLabel={tab.countLabel}
        granularity={filters.granularity}
        from={filters.from}
        to={filters.to}
        unique={tab.supportsUnique && filters.unique}
      />
    ))}
  </Box>
);
